import { render } from "./SidebarNavSection.vue?vue&type=template&id=a51450f2"
import script from "./SidebarNavSection.vue?vue&type=script&lang=js"
export * from "./SidebarNavSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__